export const Register = "/register";
export const Login = "/login";
export const Page404 = "/404";
export const Page500 = "/505";
export const Dashboard = "/dashboard";

export const Templates = "/templates";
export const GenrateCertificates = "/generateCertificates";
export const DownloadCertificates = "/downloadCertificates";
export const AddTemplates = "/addTemplates";
export const ApiCirtificate = "/apiCirtificate";
export const CreateBatch = "/createBatch";
export const ManageBatch = "/manageBatch";
export const viewCandidates = `/viewCandidates`;
export const apiTemplate = "/api-template";
export const addApiTemplate = '/add-api-template';
export const generateApiCertificate = '/generate-api-certificate'
export const activity = '/activity'
export const subActivity = '/sub-activity'
export const userType = '/usertype'
export const activityTemplate = '/activity-template'
export const manageUsers = '/manage_users'
export const usersList = '/users-list'
export const activityTemplateList = '/activity-template-list'
export const userList = '/userList'


